import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Col, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane} from 'reactstrap';
import classnames from 'classnames';
import attachmentsActionCreators from '../../store/attachments/action-creators';
import notesActionCreators from '../../store/notes/action-creators';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import DynamicForm from './dynamic-form/DynamicForm';
import AttachmentList from './attachments/AttachmentList';
import AttachmentAdd from './attachments/AttachmentAdd';
import NoteAdd from './notes/NoteAdd';
import NoteEdit from './notes/NoteEdit';
import NoteList from './notes/NoteList';
import Modal from '../../../shared/ui/Modal';
import {Auth} from "../../../shared/services/aws";
import notificationsActionsCreator from "../../store/notifications/action-creators";

class ReportEdit extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '2',
      authToken: '',
      selectedShift: '',
    };
  }

  componentDidMount() {
    this.props.loadReportEdit(this.props.report.guid)
    Auth.currentSession()
      .then(res => {
        this.setState({
          authToken: res.accessToken.jwtToken,
          selectedShift: this.props.report.shift
        })
      })


  }

  // ----------------------
  // Methods
  // ----------------------

  onAddAttachment() {
    this.props.addAttachment(this.props.report.guid);
  }

  onAddNote() {
    this.props.addNote(this.props.report.guid);
  }

  // ----------------------
  // Computed
  // ----------------------

  get hasValidShift() {
    return (this.props.departmentSettings.shifts
      && this.props.departmentSettings.shifts.length
      && this.state.selectedShift)
      || (!this.props.departmentSettings.shifts
        || !this.props.departmentSettings.shifts.length)
  }

  save(dynamicFormData, isAutoSave) {
    if (!isAutoSave && !this.hasValidShift) {
      this.props.notifyError('You need to select shift before submitting the report')
      return;
    }

    const formData = {
      guid: this.props.report.guid,
      responses: dynamicFormData.responses,
      signedAt: dynamicFormData.signedAt,
      shift: this.state.selectedShift
    };

    this.props.updateReportResponses(formData, isAutoSave)
      .then(() => {
        setTimeout(() => {
          this.props.onUpdateReport && this.props.onUpdateReport(this.props.report)
        }, 500)
      });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  get rejectionNote() {
    if (!this.props.report) {
      return null
    }
    let rejections = this.props.report.rejections.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.insertedAt) - new Date(a.insertedAt);
    });

    return rejections[0]
  }

  handleShiftChange(shift) {
    this.setState({
      selectedShift: shift
    });
  }

  render() {

    return (
      this.props.report && (
        <Fragment>
          <div className="download-report">
            <div className="oit-fullname">{this.props.report.getFullNameFor('acknowledger')}</div>
            <div>
              <button className="button secondary small mr-1" onClick={() => this.formRef.markReportAsNotObserved()}>
                Mark report as not observed
              </button>
              <button className="button secondary small mr-1"
                       onClick={() => this.props.onOpenDictation && this.props.onOpenDictation(this.props.report)}>
                Dictation
              </button>
              <button className="button secondary small mr-1" onClick={() => this.props.onOpenTasks && this.props.onOpenTasks(this.props.report)}>
                Tasks
              </button>
              <button className="button secondary small mr-1" onClick={() => this.props.onChangePhase && this.props.onChangePhase(this.props.report)}>
                Change phase
              </button>
              <a className="button primary small"
                 href={`/api/v1/forms/${this.props.report.formGuid}/pdf/${this.state.authToken}`}
                 download={`${this.props.report.getFullNameFor('acknowledger').replace(' ', '_')}.pdf`}>
                <i className="fa fa-download" />
                <span>Download blank Form</span>
              </a>
            </div>
          </div>

          {this.props.departmentSettings.shifts && this.props.departmentSettings.shifts.length > 0 &&
          <div className="shift-selection-container">
            <label className="shift-label">
              Select Shift
            </label>

            <div className="dropdown-container">
              <Input
                className="select-shift"
                name="shift"
                onChange={event => this.handleShiftChange(event.target.value)}
                type="select"
                value={this.state.selectedShift}
              >
                <option key="" value=""></option>
                {this.props.departmentSettings.shifts.map((shift) => (
                  <option
                    key={shift}
                    value={shift}
                  >
                    {shift}
                  </option>
                ))}
              </Input>
            </div>
          </div>
          }

          {this.props.report.status === 'rejected' && this.rejectionNote &&
          (!this.props.userContext.hasScope(['oit']) || this.props.report.getIsUserAuthor(this.props.userContext.userGuid)) && (
            <div className="report-rejections">
              <h4>Rejection Note </h4>
              {this.rejectionNote.reason}
            </div>
          )}
          <DynamicForm
            ref={instance => this.formRef = instance}
            layout={this.props.report.layout}
            onSave={dynamicFormData => this.save(dynamicFormData)}
            onAutoSave={dynamicFormData => this.save(dynamicFormData, true)}
            responses={this.props.report.getResponses()}
            schedule={this.props.report.schedule}
            settings={this.props.report.settings}
            overrideResponses={this.props.overrideResponses}
            acknowledger={this.props.report.acknowledger}
            hasValidShift={this.hasValidShift}
            notifyError={this.props.notifyError}
          >
            <div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === '1',
                    })}
                    onClick={() => {
                      this.toggle('1');
                    }}
                  >
                    Attachments
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: this.state.activeTab === '2',
                    })}
                    onClick={() => {
                      this.toggle('2');
                    }}
                  >
                    Notes
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <AttachmentList
                        attachments={this.props.attachments}
                        onAdd={() => this.onAddAttachment()}
                        onDelete={index => this.deleteAttachment(index)}
                      />
                      <Modal
                        isOpen={this.props.isAddingAttachment}
                        onClose={() => this.props.closeAddAttachment()}
                        title={`Add Attachment for ${
                          this.props.report.type
                          }`}
                      >
                        <AttachmentAdd />
                      </Modal>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col sm="12">
                      <NoteList
                        onAdd={() => this.onAddNote()}
                        notes={this.props.notes}
                      />
                      <Modal
                        isOpen={this.props.isAddingNote}
                        onClose={() => this.props.closeAddNote()}
                        title={`Add Note for ${
                          this.props.report.type
                          }`}
                      >
                        <NoteAdd />
                      </Modal>
                      <Modal
                        isOpen={this.props.isEditingNote}
                        onClose={() => this.props.closeEditNote()}
                        title={`Edit Note for ${this.props.report.formName}`}
                      >
                        <NoteEdit />
                      </Modal>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </DynamicForm>
        </Fragment>
      ) || null
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    attachments: state.attachments.list,
    isAddingAttachment: !!state.attachments.addingAttachmentFor,
    isAddingNote: !!state.notes.addingNoteFor,
    isAddingScheduedReport: state.trainingPhases.isAddingScheduledReport,
    isEditingNote: !!state.notes.isEditingNote,
    notes: state.notes.list,
    report: trainingPhasesSelectors.editingReport(state),
    trainingPhaseGuid: state.trainingPhases.selectedGuid,
    userContext: state.common.userContext,
    departmentSettings: state.departmentSettings.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNote: (reportGuid) => {
      return dispatch(notesActionCreators.addNote(reportGuid));
    },
    addAttachment: (reportGuid) => {
      return dispatch(attachmentsActionCreators.addAttachment(reportGuid));
    },
    closeAddAttachment: () => {
      return dispatch(attachmentsActionCreators.closeAddAttachment());
    },
    closeAddNote: () => {
      return dispatch(notesActionCreators.closeAddNote());
    },
    closeEditNote: () => {
      return dispatch(notesActionCreators.closeEditNote());
    },
    updateReport: (formData) => {
      dispatch(trainingPhasesActionCreators.updateReportResponses(formData));
    },
    updateReportResponses: (formData, isAutoSave) => {
      return dispatch(trainingPhasesActionCreators.updateReportResponses(formData, isAutoSave));
    },
    loadReportEdit: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.loadReportEdit(reportGuid));
    },
    notifyError: (message) =>
      dispatch(notificationsActionsCreator.addError(message))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportEdit);
